module.exports = __webpack_public_path__ + "static/media/brand2.1bedb036.jpeg";